import Vue from 'vue';
import Cache from './cache.js';
export default {

  sport_by_id(id) {
  	var data = Cache.get("fanseat");
  	var sports = data["sports"];
  	if (typeof(sports) == "undefined") return undefined;

    return sports.filter((sport) => {
      return sport.value == id;
    })[0];
  },
  serie_by_id(id) {
 		var data = Cache.get("fanseat");
  	var series = data["series"];
  	if (typeof(series) == "undefined") return undefined;


    return series.filter((serie) => {
      return serie.league_id == id;
    })[0];
  },

	load_sports_and_series(cb) {
		function proceed() {
			var data = Cache.get("fanseat")
			cb(data["sports"], data["series"]);
		}

		if (Cache.is("fanseat") == true) {
			proceed();

		} else {
			if (Cache.get_loading("fanseat") === true) {
				Cache.watch_loading("fanseat", function(val) {
					proceed();
				});
			} else {
				Cache.set_loading("fanseat", true);
				this.load_sports_and_series_from_api(function(sport, series) {
					Cache.set("fanseat", {"sports": sport, "series": series});
					Cache.set_loading("fanseat", false);
					proceed();
				}, function() {
					Cache.set_loading("fanseat", false);
					proceed();
				});
			}
		}
	},

	load_sports_and_series_from_api(cb, error_cb) {
      Vue.http.get("https://api5.fanseat.com/prod/sports/en",null).then((response) => {
        var sports = _.map(response.body, function(sport) {
          return {label: sport.name, value: sport.sport_id};
        });

        sports.sort(function(a,b) {
          var nameA = a.label.toUpperCase(); // ignore upper and lowercase
          var nameB = b.label.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {return -1;}
          if (nameA > nameB) {return 1;}
          return 0;
        });

        Vue.http.get("https://api5.fanseat.com/prod/leagues/en", null).then((response) => {
          var series = _.map(response.body, function(serie) {
            var name = serie.name.en || serie.name[Object.keys(serie.name)[0]];
            return {league_id: serie.league_id, name: name, sport_id: serie.sport_id, team_list_id: serie.team_list_id}
          });
          cb(sports, series);
        }, (response) => {
        	error_cb();
          console.log("Cannot load series");
        });

      }, (response) => {
      	error_cb();
        console.log("Cannot load sports");
      });

	}

}